var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
/*
 * Copyright (c) 2023 LS ELECTRIC Co. Ltd. All Reserved.
 */
/*******************************************************************
 * @author HyeongJin OH
 * @contact hjoh@detech.co.kr
 * @date 2024-08-21
 * @brief SEI 에너지솔루션 관리 -고객 요청 설비 개발
 *
 ********************************************************************/
import { useEffect, useState } from "react";
import EhpPagination from "@components/common/pagination/EhpPagination";
import { alertState } from "@recoil/assessmentState";
import { loadingBoxState } from "@recoil/menuState";
import { reLoad, userInfoLoginState } from "@recoil/userState";
import * as HTTPUTIL from "@utils/api/HttpUtil";
import * as CUTIL from "@utils/commUtils";
import * as CONST from "@utils/Const";
import { useAsync } from "react-async";
import { useRecoilState, useRecoilValue, useSetRecoilState } from "recoil";
//압축 다운로드
export default function CustomerRequestFacility(props) {
    //recoil
    const userInfo = useRecoilValue(userInfoLoginState);
    const setRecoilIsLoadingBox = useSetRecoilState(loadingBoxState);
    const [alerts, setAlerts] = useRecoilState(alertState);
    const [reload, setReload] = useRecoilState(reLoad);
    //props
    const { handleOpenPop } = props;
    //
    const [listItem, setListItem] = useState([]);
    const [detailItem, setDetailItem] = useState(null);
    const [checkItem, setCheckItem] = useState([]);
    const [checkArr, setCheckArr] = useState([]);
    const [zoneItem, setZoneItem] = useState([]);
    const [zone, setZone] = useState(null);
    const [spgItem, setSpgItem] = useState([]);
    const [spg, setSpg] = useState(null);
    const defaultPageInfo = { size: 10, totalElements: 0, totalPages: 0, number: 0, psize: 10, listReload: false };
    const [pageInfo, setPageInfo] = useState(defaultPageInfo);
    function handleCurPage(page) {
        setPageInfo(Object.assign(Object.assign({}, pageInfo), { number: page }));
        // HightManagementList(subGroup.spgId, page);
    }
    const [sortData, setSortData] = useState({
        sortField: "",
        sort: "asc",
    });
    let appPath = ``;
    // 설비 유형 검색
    if (spg) {
        appPath = appPath + `?spgId=${spg.spgId}`;
    }
    // 정렬 적용된
    if (sortData.sortField) {
        if (!zone && !spg) {
            appPath = appPath + `?sort=${sortData.sortField},${sortData.sort}`;
        }
        else {
            appPath = appPath + `&sort=${sortData.sortField},${sortData.sort}`;
        }
    }
    // custNo 검색
    if (zone) {
        if (sortData.sortField.length <= 0 && !spg) {
            appPath = appPath + `?custNo=${zone.custNo}`;
        }
        else {
            appPath = appPath + `&custNo=${zone.custNo}`;
        }
    }
    // List API
    const { data: data, isLoading } = useAsync({
        promiseFn: HTTPUTIL.PromiseHttp,
        httpMethod: "GET",
        appPath: `/energyreport/highitemmngt/list${appPath}`,
        appQuery: {},
        userToken: userInfo.loginInfo.token,
        watch: appPath + reload,
    });
    useEffect(() => {
        if (data) {
            if (data.codeNum == CONST.API_200) {
                setListItem(data.body);
                setDetailItem(data.body[0]);
                setPageInfo(Object.assign(Object.assign({}, data.data.page), { psize: data.data.page.totalElements })); //5, 10; // psize: (isMobile) ? CONST.NUM_MLISTCNT : CONST.NUM_WLISTCNT, "listReload": false,
                setReload(false);
            }
            else {
                setAlerts(Object.assign(Object.assign({}, alerts), { type: CONST.TYPE_ERROR, divTag: data.errorList !== null ? data.errorList.map((err) => err.msg) : CONST.ERROR_MSG }));
                CUTIL.jsopen_AlertPopup(CONST.POP_ALERT);
                setRecoilIsLoadingBox(false);
            }
        }
    }, [data, reload]);
    const { data: zoneData } = useAsync({
        promiseFn: HTTPUTIL.PromiseHttp,
        httpMethod: "GET",
        appPath: `/energyreport/address/zones`,
        appQuery: {},
        userToken: userInfo.loginInfo.token,
    });
    useEffect(() => {
        if (zoneData) {
            if (zoneData.codeNum == CONST.API_200) {
                const reData = zoneData.body.map((item) => (Object.assign(Object.assign({}, item), { name: item.zoneId.split(":")[0] + " " + item.zoneId.split(":")[1] })));
                setZoneItem(reData);
            }
            else {
                setAlerts(Object.assign(Object.assign({}, alerts), { type: CONST.TYPE_ERROR, divTag: zoneData.errorList !== null ? zoneData.errorList.map((err) => err.msg) : CONST.ERROR_MSG }));
                CUTIL.jsopen_AlertPopup(CONST.POP_ALERT);
                setRecoilIsLoadingBox(false);
            }
        }
    }, [zoneData]);
    const { data: spgData } = useAsync({
        promiseFn: HTTPUTIL.PromiseHttp,
        httpMethod: "GET",
        appPath: `/product/spgs/equipchange`,
        appQuery: {},
        userToken: userInfo.loginInfo.token,
    });
    useEffect(() => {
        if (spgData) {
            if (spgData.codeNum == CONST.API_200) {
                const subGroup = [];
                spgData.body.map((item) => item.subGroup.map((sitem) => subGroup.push(sitem)));
                setSpgItem(subGroup);
            }
            else {
                setAlerts(Object.assign(Object.assign({}, alerts), { type: CONST.TYPE_ERROR, divTag: spgData.errorList !== null ? spgData.errorList.map((err) => err.msg) : CONST.ERROR_MSG }));
                CUTIL.jsopen_AlertPopup(CONST.POP_ALERT);
                setRecoilIsLoadingBox(false);
            }
        }
    }, [data]);
    // 정렬 버튼 액션
    const onClickSort = (sort) => {
        // list 수정
        handleCurPage(0);
        const sortVal = {
            field: sort,
            data: sortData,
            setData: setSortData,
        };
        CUTIL.onClickSort(sortVal);
    };
    // list 선택 시
    const listSelect = (e, item) => {
        if (e.target.nodeName !== "LABEL" && e.target.nodeName !== "INPUT")
            setDetailItem(item);
    };
    const highItemEdit = (id, type) => __awaiter(this, void 0, void 0, function* () {
        setRecoilIsLoadingBox(true);
        let data = null;
        data = yield HTTPUTIL.PromiseHttp({
            httpMethod: "PUT",
            appPath: `/energyreport/highitemmngt/${id}/${type}`,
            appQuery: {},
            userToken: userInfo.loginInfo.token,
        });
        if (data) {
            if (data.codeNum == CONST.API_200) {
                setAlerts(Object.assign(Object.assign({}, alerts), { type: CONST.TYPE_ERROR, divTag: data.errorList !== null ? data.body : CONST.ERROR_MSG, callBack: () => {
                        handleCurPage(0);
                        setSortData({
                            sortField: "",
                            sort: "asc",
                        });
                        setReload(true);
                        CUTIL.jsclose_Popup(CONST.POP_ALERT);
                    } }));
                CUTIL.jsopen_AlertPopup(CONST.POP_ALERT);
                setRecoilIsLoadingBox(false);
            }
            else {
                setAlerts(Object.assign(Object.assign({}, alerts), { type: CONST.TYPE_ERROR, divTag: data.errorList !== null ? data.errorList.map((err) => err.msg) : CONST.ERROR_MSG, callBack: () => {
                        CUTIL.jsclose_Popup(CONST.POP_ALERT);
                    } }));
                CUTIL.jsopen_AlertPopup(CONST.POP_ALERT);
                setRecoilIsLoadingBox(false);
            }
        }
    });
    // custNo 선택
    const searchZone = (item) => {
        setZone(item);
    };
    // spg 선택
    const spgSelect = (item) => {
        setSpg(item);
    };
    // 삭제 팝업
    const customizedHighDeletePop = (e, type, highId) => __awaiter(this, void 0, void 0, function* () {
        if (highId) {
            handleOpenPop("pop-delete", _jsx(DeletePop, { highId: highId, type: type, handleCurPage: handleCurPage, setSortData: handleCurPage, setCheckIte: setCheckItem, setCheckArr: setCheckArr }));
        }
        else {
            handleOpenPop("pop-delete", _jsx(DeletePop, { type: type, handleCurPage: handleCurPage, setSortData: handleCurPage, checkArr: checkArr, setCheckIte: setCheckItem, setCheckArr: setCheckArr }));
        }
        CUTIL.jsopen_Popup(e);
    });
    function CheckedAll(checked) {
        if (checked) {
            const checks = checkItem.concat(listItem); // 전체 list
            const checksId = checkArr.concat(listItem.map((item) => item.id)); // id list
            var unique = checks.filter((item, pos) => checksId.indexOf(item.id) === pos);
            var uniqueId = checksId.filter((item, pos) => checksId.indexOf(item) === pos);
            setCheckArr(uniqueId);
            setCheckItem(unique);
        }
        else {
            let itemListId = listItem.map((item) => item.id);
            setCheckItem(checkItem.filter((item) => !itemListId.includes(item.id)));
            setCheckArr(checkArr.filter((item) => !itemListId.includes(item)));
        }
    }
    // checkbox
    function CheckedList(checked, list) {
        if (checked) {
            setCheckItem([...checkItem, list]);
            setCheckArr([...checkArr, list.id]);
        }
        else {
            setCheckItem(checkItem.filter((el) => el.id !== list.id));
            setCheckArr(checkArr.filter((el) => el !== list.id));
        }
    }
    return (_jsxs(_Fragment, { children: [_jsxs("article", Object.assign({ className: "flex-7" }, { children: [_jsx("div", Object.assign({ className: "box__header flex-column brd-bottom-0 pb-0" }, { children: _jsx("h2", Object.assign({ className: "box__title" }, { children: "\uACE0\uAC1D \uC694\uCCAD \uC124\uBE44" })) })), _jsxs("div", Object.assign({ className: `box__body pt-0 ${listItem.length <= 0 ? "nodata" : ""}` }, { children: [_jsxs("div", Object.assign({ className: "tbl__top mt-46" }, { children: [_jsx("div", Object.assign({ className: "left" }, { children: _jsx("div", Object.assign({ className: "searcharea" }, { children: _jsxs("div", Object.assign({ className: "searchinput" }, { children: [_jsxs("div", Object.assign({ className: "select company w280", onClick: (e) => CUTIL.onClickSelect(e, CUTIL.selectOption) }, { children: [_jsxs("div", Object.assign({ className: "selected" }, { children: [_jsx("div", Object.assign({ className: "selected-value" }, { children: zone ? zone.name : "회사 사업장" })), _jsx("div", { className: "arrow" })] })), _jsxs("ul", { children: [_jsx("li", Object.assign({ className: "option", onClick: (e) => searchZone(null) }, { children: "\uC804\uCCB4" })), zoneItem &&
                                                                        zoneItem.map((list, idx) => (_jsx("li", Object.assign({ className: "option", onClick: (e) => searchZone(list) }, { children: list.name }), "custNoList_" + idx.toString())))] })] })), _jsxs("div", Object.assign({ className: "select spg w280", onClick: (e) => CUTIL.onClickSelect(e, CUTIL.selectOption) }, { children: [_jsxs("div", Object.assign({ className: "selected" }, { children: [_jsx("div", Object.assign({ className: "selected-value" }, { children: spg ? spg.name : "설비 상세 유형" })), _jsx("div", { className: "arrow" })] })), _jsxs("ul", { children: [_jsx("li", Object.assign({ className: "option", onClick: (e) => spgSelect(null) }, { children: "\uC804\uCCB4" })), spgItem &&
                                                                        spgItem.map((list, idx) => (_jsx("li", Object.assign({ className: "option", onClick: (e) => spgSelect(list) }, { children: list.name }), "subList_" + idx.toString())))] })] }))] })) })) })), _jsx("div", Object.assign({ className: "right" }, { children: _jsx("button", Object.assign({ type: "button", className: "btn-basic js-open", "data-pop": "pop-delete", onClick: (e) => customizedHighDeletePop(e, "d"), disabled: checkArr.length > 0 ? false : true }, { children: _jsx("span", { children: "\uC0AD\uC81C" }) })) }))] })), _jsx("p", Object.assign({ className: "nodata__txt" }, { children: "\uB370\uC774\uD130\uB97C \uCC3E\uC744 \uC218 \uC5C6\uC2B5\uB2C8\uB2E4." })), _jsx("div", Object.assign({ className: "tbl-list tbl-select line-1 hcal-70" }, { children: _jsxs("table", Object.assign({ summary: "\uD68C\uC0AC \uC0AC\uC5C5\uC7A5, \uC124\uBE44 \uC0C1\uC138 \uC720\uD615, \uD615\uBA85, \uC81C\uC870\uC0AC, \uC694\uCCAD\uC77C, \uD655\uC778 \uC5EC\uBD80 \uD56D\uBAA9\uC73C\uB85C \uAD6C\uC131\uB41C \uACE0\uAC1D \uC694\uCCAD \uC124\uBE44 List \uC785\uB2C8\uB2E4." }, { children: [_jsx("caption", { children: "\uACE0\uAC1D \uC694\uCCAD \uC124\uBE44 List" }), _jsxs("colgroup", { children: [_jsx("col", { style: { width: "5%" } }), _jsx("col", { style: { width: "17%" } }), _jsx("col", { style: { width: "12%" } }), _jsx("col", { style: { width: "15%" } }), _jsx("col", { style: { width: "14%" } }), _jsx("col", { style: { width: "14%" } }), _jsx("col", { style: { width: "11%" } }), _jsx("col", { style: { width: "12%" } })] }), _jsx("thead", { children: _jsxs("tr", { children: [_jsxs("th", Object.assign({ scope: "col", className: "txt-left" }, { children: [_jsx("input", { type: "checkbox", id: "t_all", checked: checkArr.length === 0
                                                                    ? false
                                                                    : listItem.length == listItem.filter((list) => checkArr.includes(list.id)).length
                                                                        ? true
                                                                        : false, onChange: (e) => CheckedAll(e.target.checked) }), _jsx("label", Object.assign({ htmlFor: "t_all" }, { children: _jsx("span", Object.assign({ className: "hide" }, { children: "\uC120\uD0DD" })) }))] })), _jsx("th", Object.assign({ scope: "col", className: "txt-left" }, { children: _jsx("span", { children: "\uD68C\uC0AC \uC0AC\uC5C5\uC7A5" }) })), _jsx("th", Object.assign({ scope: "col" }, { children: _jsx("span", { children: "\uC124\uBE44 \uC0C1\uC138 \uC720\uD615" }) })), _jsx("th", Object.assign({ scope: "col" }, { children: _jsx("span", {}) })), _jsx("th", Object.assign({ scope: "col", className: `sort ${sortData.sortField === "itemName" && sortData.sort === "desc" ? "desc" : "asc"}`, onClick: (e) => onClickSort("itemName") }, { children: _jsx("span", { children: "\uD615 \uBA85" }) })), _jsx("th", Object.assign({ scope: "col", className: `sort ${sortData.sortField === "manufacturer" && sortData.sort === "desc" ? "desc" : "asc"}`, onClick: (e) => onClickSort("manufacturer") }, { children: _jsx("span", { children: "\uC81C\uC870\uC0AC" }) })), _jsx("th", Object.assign({ scope: "col", className: `sort ${sortData.sortField === "createdTime" && sortData.sort === "desc" ? "desc" : "asc"}`, onClick: (e) => onClickSort("createdTime") }, { children: _jsx("span", { children: "\uC694\uCCAD\uC77C" }) })), _jsx("th", Object.assign({ scope: "col", className: `sort ${sortData.sortField === "status" && sortData.sort === "desc" ? "desc" : "asc"}`, onClick: (e) => onClickSort("status") }, { children: _jsx("span", { children: "\uD655\uC778 \uC5EC\uBD80" }) }))] }) }), _jsx("tbody", { children: listItem &&
                                                listItem.map((list, idx) => (_jsxs("tr", Object.assign({ className: detailItem == list ? "selected" : "", onClick: (e) => listSelect(e, list) }, { children: [_jsxs("td", { children: [_jsx("input", { type: "checkbox", id: "t_" + idx, checked: checkArr.includes(list.id) ? true : false, onChange: (e) => CheckedList(e.target.checked, list), style: { display: "none" } }), _jsx("label", Object.assign({ htmlFor: "t_" + idx }, { children: _jsx("span", Object.assign({ className: "hide" }, { children: "\uC120\uD0DD" })) }))] }), _jsx("td", { children: _jsx("p", Object.assign({ className: "ellipsis" }, { children: `${list.zoneId.split(":")[0]} ${list.zoneId.split(":")[1]}` })) }), _jsx("td", { children: _jsx("p", Object.assign({ className: "ellipsis" }, { children: list.spgGroupName })) }), _jsx("td", { children: _jsx("p", Object.assign({ className: "ellipsis" }, { children: list.spgName })) }), _jsx("td", { children: _jsx("p", Object.assign({ className: "ellipsis" }, { children: list.itemName })) }), _jsx("td", { children: _jsx("p", Object.assign({ className: "ellipsis" }, { children: list.manufacturer })) }), _jsx("td", { children: _jsx("p", Object.assign({ className: "ellipsis" }, { children: list.createdTime })) }), _jsx("td", { children: list.status == 1 ? (_jsx("button", Object.assign({ type: "button", className: "btn-basic" }, { children: _jsx("span", { children: "\uD655\uC778" }) }))) : list.status == 2 ? (_jsx("button", Object.assign({ type: "button", className: "btn-basic bg-gray" }, { children: _jsx("span", { children: "\uC804\uCCB4\uBC18\uC601" }) }))) : (list.status == 3 && (_jsx("button", Object.assign({ type: "button", className: "btn-basic bg-gray" }, { children: _jsx("span", { children: "\uB300\uC0C1\uC544\uB2D8" }) })))) })] }), "customList_" + idx.toString()))) })] })) })), _jsx(EhpPagination, { componentName: "HIGHTMANAGEMENTCUSTOM", pageInfo: pageInfo, handleCurPage: handleCurPage, checked: checkArr })] }))] })), _jsx("article", Object.assign({ className: "flex-3" }, { children: _jsxs("div", Object.assign({ className: `box__body p-40 ${!detailItem ? "nodata" : ""}` }, { children: [_jsx("h3", Object.assign({ className: "title" }, { children: "\uC694\uCCAD \uC815\uBCF4" })), _jsx("p", Object.assign({ className: "nodata__txt" }, { children: "\uB370\uC774\uD130\uB97C \uCC3E\uC744 \uC218 \uC5C6\uC2B5\uB2C8\uB2E4." })), detailItem && (_jsxs("ul", Object.assign({ className: "form__input mt-24" }, { children: [_jsxs("li", { children: [_jsx("p", Object.assign({ className: "tit star" }, { children: "\uD68C\uC0AC" })), _jsx("div", Object.assign({ className: "input__area" }, { children: _jsx("input", { type: "text", id: "inp221", value: detailItem.zoneId.split(":")[0], readOnly: true }) }))] }), _jsxs("li", { children: [_jsx("p", Object.assign({ className: "tit star" }, { children: "\uC0AC\uC5C5\uC7A5" })), _jsx("div", Object.assign({ className: "input__area" }, { children: _jsx("input", { type: "text", id: "inp222", value: detailItem.zoneId.split(":")[1], readOnly: true }) }))] }), _jsx("h3", Object.assign({ className: "title" }, { children: "\uC124\uBE44 \uC815\uBCF4" })), _jsxs("ul", Object.assign({ className: "form__input mt-24" }, { children: [_jsxs("li", { children: [_jsx("p", Object.assign({ className: "tit star" }, { children: "\uC124\uBE44 \uC720\uD615" })), _jsx("div", Object.assign({ className: "input__area" }, { children: _jsx("input", { type: "text", id: "inp221", value: detailItem.spgName, readOnly: true }) }))] }), _jsxs("li", { children: [_jsx("p", Object.assign({ className: "tit star" }, { children: "\uD615 \uBA85" })), _jsx("div", Object.assign({ className: "input__area" }, { children: _jsx("input", { type: "text", id: "inp222", value: detailItem.itemName, readOnly: true }) }))] }), _jsxs("li", { children: [_jsx("p", Object.assign({ className: "tit star" }, { children: "\uC81C\uC870\uC0AC" })), _jsx("div", Object.assign({ className: "input__area" }, { children: _jsx("input", { type: "text", id: "inp232", value: detailItem.manufacturer, readOnly: true }) }))] }), detailItem.elecInfos.map((list, idx) => (_jsxs("li", { children: [_jsxs("p", Object.assign({ className: "tit star mt-0" }, { children: [list.name, " ", list.type < 2 ? `(${list.unit})` : ""] })), _jsx("div", Object.assign({ className: "input__area" }, { children: _jsx("input", { type: "text", id: "inp233", value: list.value, readOnly: true }) }))] }, "elecInfos_" + idx.toString()))), _jsx("li", { children: _jsxs("div", Object.assign({ className: "btn__wrap flex-right" }, { children: [detailItem.status < 2 && (_jsx("button", Object.assign({ type: "button", className: "btn-basic", onClick: (e) => highItemEdit(detailItem.id, "noUse") }, { children: _jsx("span", { children: "\uB300\uC0C1 \uC544\uB2D8" }) }))), detailItem.status < 2 && (_jsx("button", Object.assign({ type: "button", className: "btn-basic", onClick: (e) => highItemEdit(detailItem.id, "use") }, { children: _jsx("span", { children: "\uC804\uCCB4 \uBC18\uC601" }) }))), detailItem.status > 1 && (_jsx("button", Object.assign({ type: "button", className: "btn-basic js-open", "data-pop": "pop-delete", onClick: (e) => customizedHighDeletePop(e, "s", detailItem.id) }, { children: _jsx("span", { children: "\uC0AD\uC81C" }) })))] })) })] }))] })))] })) }))] }));
}
function DeletePop(props) {
    const userInfo = useRecoilValue(userInfoLoginState);
    const setRecoilIsLoadingBox = useSetRecoilState(loadingBoxState);
    const [alerts, setAlerts] = useRecoilState(alertState);
    const setReload = useSetRecoilState(reLoad);
    const { type, handleCurPage, setSortData, setCheckIte, setCheckArr } = props;
    const highId = props.hasOwnProperty("highId") ? props.highId : null;
    const checkArr = props.hasOwnProperty("checkArr") ? props.checkArr : null;
    const customizedHighDelete = (type) => __awaiter(this, void 0, void 0, function* () {
        setRecoilIsLoadingBox(true);
        let data = null;
        if (type == "s") {
            data = yield HTTPUTIL.PromiseHttp({
                httpMethod: "DELETE",
                appPath: `/energyreport/customizedhighitem/${highId}`,
                appQuery: {},
                userToken: userInfo.loginInfo.token,
            });
            if (data) {
                if (data.codeNum == CONST.API_200) {
                    CUTIL.jsclose_Popup("pop-delete");
                    setAlerts(Object.assign(Object.assign({}, alerts), { type: CONST.TYPE_ERROR, divTag: data.errorList !== null ? data.body : CONST.ERROR_MSG, callBack: () => {
                            handleCurPage(0);
                            setSortData({
                                sortField: "",
                                sort: "asc",
                            });
                            setReload(true);
                            CUTIL.jsclose_Popup(CONST.POP_ALERT);
                        } }));
                    CUTIL.jsopen_AlertPopup(CONST.POP_ALERT);
                    setRecoilIsLoadingBox(false);
                }
                else {
                    setAlerts(Object.assign(Object.assign({}, alerts), { type: CONST.TYPE_ERROR, divTag: data.errorList !== null ? data.errorList.map((err) => err.msg) : CONST.ERROR_MSG }));
                    CUTIL.jsopen_AlertPopup(CONST.POP_ALERT);
                    setRecoilIsLoadingBox(false);
                }
            }
        }
        else {
            let success = [];
            let fail = [];
            for (let i = 0; i < checkArr.length; i++) {
                data = yield HTTPUTIL.PromiseHttp({
                    httpMethod: "DELETE",
                    appPath: `/energyreport/customizedhighitem/${checkArr[i]}`,
                    appQuery: {},
                    userToken: userInfo.loginInfo.token,
                });
                if (data) {
                    if (data.codeNum == CONST.API_200) {
                        success.push(data.body);
                    }
                    else {
                        fail.push(data.errorList);
                    }
                }
            }
            if (data) {
                CUTIL.jsclose_Popup("pop-delete");
                if (success.length > 0) {
                    setAlerts(Object.assign(Object.assign({}, alerts), { type: CONST.TYPE_ERROR, divTag: data.errorList !== null ? data.body : CONST.ERROR_MSG, callBack: () => {
                            setCheckIte([]);
                            setCheckArr([]);
                            handleCurPage(0);
                            setSortData({
                                sortField: "",
                                sort: "asc",
                            });
                            setReload(true);
                            CUTIL.jsclose_Popup(CONST.POP_ALERT);
                        } }));
                    CUTIL.jsopen_AlertPopup(CONST.POP_ALERT);
                    setRecoilIsLoadingBox(false);
                }
                else if (success.length > 0 && fail.length > 0) {
                    setAlerts(Object.assign(Object.assign({}, alerts), { type: CONST.TYPE_NONE, pTag: {
                            p1: `성공 ${success.length} 건 입니다.`,
                            p2: `실패 ${fail.length} 건 입니다.`,
                        }, callBack: () => {
                            setCheckIte([]);
                            setCheckArr([]);
                            handleCurPage(0);
                            setSortData({
                                sortField: "",
                                sort: "asc",
                            });
                            setReload(true);
                            CUTIL.jsclose_Popup(CONST.POP_ALERT);
                        } }));
                    CUTIL.jsopen_AlertPopup(CONST.POP_ALERT);
                    setRecoilIsLoadingBox(false);
                }
                else {
                    setAlerts(Object.assign(Object.assign({}, alerts), { type: CONST.TYPE_NONE, divTag: "삭제를 실패했습니다" }));
                    CUTIL.jsopen_AlertPopup(CONST.POP_ALERT);
                    setRecoilIsLoadingBox(false);
                }
            }
        }
    });
    return (_jsxs(_Fragment, { children: [_jsx("div", Object.assign({ className: "popup__body" }, { children: _jsxs("p", { children: ["\uC124\uBE44\uC720\uD615\uC744 \uC0AD\uC81C\uD558\uC2DC\uACA0\uC2B5\uB2C8\uAE4C? ", _jsx("br", {}), "\uC124\uBE44\uC720\uD615 \uC0AD\uC81C \uC2DC \uD574\uB2F9 \uC124\uBE44\uC720\uD615 \uAD00\uB828 \uB370\uC774\uD130\uAC00 \uBAA8\uB450 \uC0AD\uC81C\uB429\uB2C8\uB2E4."] }) })), _jsxs("div", Object.assign({ className: "popup__footer" }, { children: [_jsx("button", Object.assign({ type: "button", className: "bg-gray js-close", onClick: (e) => CUTIL.jsclose_Popup("pop-delete") }, { children: _jsx("span", { children: "\uCDE8\uC18C" }) })), _jsx("button", Object.assign({ type: "button", onClick: (e) => customizedHighDelete(type) }, { children: _jsx("span", { children: "\uD655\uC778" }) }))] }))] }));
}
